/* Store detail page: Open now badge, "Today" row highlight, photo thumbnails */
(function () {
  if (window.__spStorePage) return;
  window.__spStorePage = true;

  function nowIn(tz) {
    var opts = { weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false };
    var parts;
    try { parts = new Intl.DateTimeFormat('en-US', Object.assign({ timeZone: tz }, opts)).formatToParts(new Date()); }
    catch (e) { parts = new Intl.DateTimeFormat('en-US', opts).formatToParts(new Date()); }
    var get = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return ''; };
    return { day: get('weekday').toLowerCase().slice(0, 3), mins: (parseInt(get('hour'), 10) % 24) * 60 + parseInt(get('minute'), 10) };
  }

  function isOpen(range, mins) {
    var m = /^(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})$/.exec(range || '');
    if (!m) return false;
    var o = +m[1] * 60 + +m[2], c = +m[3] * 60 + +m[4];
    if (c <= o) c += 1440; // closes after midnight
    return (mins >= o && mins < c) || (mins + 1440 >= o && mins + 1440 < c);
  }

  function initHours(el) {
    var hours = {}, fmt = {};
    try { hours = JSON.parse(el.getAttribute('data-sp-hours') || '{}'); fmt = JSON.parse(el.getAttribute('data-sp-hours-fmt') || '{}'); } catch (e) { return; }
    var now = nowIn(el.getAttribute('data-sp-tz') || undefined);

    el.querySelectorAll('[data-sp-day]').forEach(function (row) {
      if (row.getAttribute('data-sp-day') === now.day) row.classList.add('is-today');
    });

    el.querySelectorAll('[data-sp-status-hours]').forEach(function (h) { h.textContent = fmt[now.day] || ''; });
    var st = el.querySelector('[data-sp-status]');
    if (!st) return;
    var today = hours[now.day];
    if (!today) return; // no hours entered – keep badge hidden
    var open = isOpen(today, now.mins);
    st.classList.add(open ? 'is-open' : 'is-closed');
    st.querySelector('[data-sp-status-label]').textContent = open
      ? (el.getAttribute('data-open-label') || 'Open Now')
      : (el.getAttribute('data-closed-label') || 'Closed Now');
    st.hidden = false;
  }

  function initGallery(g) {
    var main = g.querySelector('.sp-main-img');
    g.querySelectorAll('[data-sp-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = btn.getAttribute('data-sp-thumb');
        g.querySelectorAll('[data-sp-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      });
    });
  }

  /* ---- City page: search, show more, nearest first ---- */
  function initCityList(root) {
    if (root.__spDone) return; root.__spDone = true;
    var list = root.querySelector('[data-sp-list]');
    if (!list) return;
    var items = [].slice.call(list.querySelectorAll('[data-sp-item]'));
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 999;
    var shown = perPage, query = '';
    var more = root.querySelector('[data-sp-more]');
    var count = root.querySelector('[data-sp-count]');
    var empty = root.querySelector('[data-sp-empty]');
    function render() {
      var visible = 0, matches = 0;
      items.forEach(function (it) {
        var ok = !query || (it.getAttribute('data-search') || '').indexOf(query) > -1;
        if (ok) matches++;
        var show = ok && (query || matches <= shown);
        it.hidden = !show;
        if (show) visible++;
      });
      if (more) more.hidden = !!query || matches <= shown;
      if (count) count.textContent = matches;
      if (empty) empty.hidden = matches > 0;
    }
    var input = root.querySelector('[data-sp-search]');
    if (input) input.addEventListener('input', function () { query = input.value.trim().toLowerCase(); render(); });
    if (more) more.addEventListener('click', function () { shown += perPage; render(); });
    var near = root.querySelector('[data-sp-nearest]');
    if (near && navigator.geolocation) {
      near.hidden = false;
      near.addEventListener('click', function () {
        near.disabled = true; near.classList.add('is-loading');
        navigator.geolocation.getCurrentPosition(function (pos) {
          var la = pos.coords.latitude, lo = pos.coords.longitude, R = 6371, rad = Math.PI / 180;
          items.forEach(function (it) {
            var a = parseFloat(it.getAttribute('data-lat')), b = parseFloat(it.getAttribute('data-lng'));
            if (isNaN(a) || isNaN(b)) { it.__d = 1e9; return; }
            var dLa = (a - la) * rad, dLo = (b - lo) * rad;
            var h = Math.sin(dLa / 2) * Math.sin(dLa / 2) + Math.cos(la * rad) * Math.cos(a * rad) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
            it.__d = 2 * R * Math.asin(Math.sqrt(h));
            var tag = it.querySelector('[data-sp-distance]');
            if (tag) { tag.textContent = it.__d < 1 ? Math.round(it.__d * 1000) + ' m away' : it.__d.toFixed(1) + ' km away'; tag.hidden = false; }
          });
          items.sort(function (x, y) { return x.__d - y.__d; });
          items.forEach(function (it) { list.appendChild(it); });
          near.disabled = false; near.classList.remove('is-loading'); near.classList.add('is-active');
          render();
        }, function () {
          near.disabled = false; near.classList.remove('is-loading');
          alert(near.getAttribute('data-error') || 'Location permission is needed to find the nearest store.');
        }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
      });
    }
    render();
  }

  /* ---- FAQ tabs ---- */
  function initFaq(root) {
    var tabs = root.querySelectorAll('[data-sp-tab]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-sp-tab');
        var mobile = window.matchMedia('(max-width: 989px)').matches;
        // on mobile a second tap on the open tab closes it (accordion)
        var closing = mobile && t.classList.contains('is-active');
        tabs.forEach(function (x) { var on = x === t && !closing; x.classList.toggle('is-active', on); x.setAttribute('aria-expanded', on); });
        root.querySelectorAll('[data-sp-panel]').forEach(function (p) { p.hidden = closing || p.getAttribute('data-sp-panel') !== id; });
      });
    });
  }

  /* ---- Store page mini map (Leaflet, English labels) ---- */
  // English-label map styles (CARTO basemaps use English/Latin names); "osm" shows local-language labels
  var TILES = {
    voyager:  { url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', sub: 'abcd', attr: '&copy; OpenStreetMap contributors &copy; CARTO' },
    positron: { url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', sub: 'abcd', attr: '&copy; OpenStreetMap contributors &copy; CARTO' },
    osm:      { url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', sub: 'abc', attr: '&copy; OpenStreetMap contributors' }
  };
  var leafletReady = null;
  function loadLeaflet() {
    if (window.L) return Promise.resolve();
    if (leafletReady) return leafletReady;
    var base = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/';
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = base + 'leaflet.min.css'; document.head.appendChild(l);
    leafletReady = new Promise(function (ok, fail) { var s = document.createElement('script'); s.src = base + 'leaflet.min.js'; s.onload = ok; s.onerror = fail; document.head.appendChild(s); });
    return leafletReady;
  }
  var PIN_SVG = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="36" viewBox="0 0 28 36"><path d="M14 1C7 1 1.5 6.4 1.5 13.3 1.5 22.5 14 35 14 35s12.5-12.5 12.5-21.7C26.5 6.4 21 1 14 1z" fill="#1f97d8" stroke="#fff" stroke-width="2.5"/><circle cx="14" cy="13" r="4.5" fill="#fff"/></svg>');
  function loadGoogle(key) {
    if (window.google && window.google.maps && window.google.maps.Map) return Promise.resolve();
    if (window.__spGoogle) return window.__spGoogle;
    window.__spGoogle = new Promise(function (ok, fail) {
      window.__spGoogleReady = function () { ok(); };
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&language=en&region=PK&loading=async&callback=__spGoogleReady';
      s.onerror = fail; document.head.appendChild(s);
      window.gm_authFailure = function () { fail(new Error('Google Maps key rejected')); document.dispatchEvent(new Event('sp:google-failed')); };
    });
    return window.__spGoogle;
  }
  function popup(name, dir, label) {
    var e = function (x) { return String(x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    return '<strong>' + e(name) + '</strong>' + (dir ? '<br><a href="' + e(dir) + '" target="_blank" rel="noopener">' + e(label) + ' →</a>' : '');
  }
  function initMiniMap(el) {
    if (el.__spMap) return; el.__spMap = true;
    var lat = parseFloat(el.getAttribute('data-lat')), lng = parseFloat(el.getAttribute('data-lng'));
    if (isNaN(lat) || isNaN(lng)) return;
    var gkey = (el.getAttribute('data-gkey') || '').trim();
    var name = el.getAttribute('data-name') || '', dir = el.getAttribute('data-dir'), dlabel = el.getAttribute('data-dir-label') || 'Get Directions';
    var zoom = parseInt(el.getAttribute('data-zoom'), 10) || 15;
    function drawGoogle() {
      document.addEventListener('sp:google-failed', function () { if (!el.__spFell) { el.__spFell = true; el.innerHTML = ''; drawLeaflet(); } });
      loadGoogle(gkey).then(function () {
        var pos = { lat: lat, lng: lng };
        var map = new google.maps.Map(el, { center: pos, zoom: zoom, mapTypeControl: false, streetViewControl: false, gestureHandling: 'cooperative' });
        var m = new google.maps.Marker({ position: pos, map: map, title: name,
          icon: { url: PIN_SVG, scaledSize: new google.maps.Size(28, 36), anchor: new google.maps.Point(14, 35) } });
        var info = new google.maps.InfoWindow({ content: '<div class="sp-gpop">' + popup(name, dir, dlabel) + '</div>' });
        m.addListener('click', function () { info.open({ map: map, anchor: m }); });
      }).catch(function () { if (!el.__spFell) { el.__spFell = true; el.innerHTML = ''; drawLeaflet(); } });
    }
    function draw() { if (gkey) drawGoogle(); else drawLeaflet(); }
    function drawLeaflet() {
      loadLeaflet().then(function () {
        var tl = TILES[el.getAttribute('data-tiles')] || TILES.voyager;
        var map = L.map(el, { scrollWheelZoom: false }).setView([lat, lng], zoom);
        L.tileLayer(tl.url, { maxZoom: 19, subdomains: tl.sub, attribution: tl.attr }).addTo(map);
        map.on('focus', function () { map.scrollWheelZoom.enable(); });
        var icon = L.divIcon({ className: 'sp-pin', html: '<span></span>', iconSize: [26, 34], iconAnchor: [13, 34], popupAnchor: [0, -30] });
        L.marker([lat, lng], { icon: icon, title: name }).addTo(map).bindPopup(popup(name, dir, dlabel));
      }).catch(function () { el.classList.add('is-error'); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); draw(); } }, { rootMargin: '300px' });
      io.observe(el);
    } else draw();
  }

  function init() {
    document.querySelectorAll('[data-sp-minimap]').forEach(initMiniMap);
    document.querySelectorAll('[data-sp-hours]').forEach(initHours);
    document.querySelectorAll('[data-sp-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-sp-city-list]').forEach(initCityList);
    document.querySelectorAll('[data-sp-faq]').forEach(initFaq);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // re-run when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
